import styled from 'styled-components';
import FlexWrap from '@/components/common/FlexWrap';
import CurrentStatus from './CurrentStatus';
import { IGlobalState } from '@/store';
import { useAppDispatch, useAppSelector } from '@/hooks/useReduxHooks';
import {
  DepartureDate,
  RefundAmount,
  RefundDetail,
  MTCN,
} from '@repo/components';
import { useState } from 'react';
import { useMutation } from 'react-query';
import { IMedicalDepartureInfoPayload } from '@/types/medical.type';
import { updateMedicalDepartureInfo } from '@/api';
import { format } from 'date-fns';
import { MTCN as MTCNType } from '@repo/types';
import { routes } from '@/constant/routes.const';
import { useHistory } from 'react-router';

type Props = {
  mtcnList: MTCNType[];
};

function TopSection({ mtcnList }: Props) {
  const history = useHistory();
  const {
    passportNumber,
    email,
    nationality,
    refundAmount,
    refundAmountDetail,
    departureDate,
    firstRefundDate,
  } = useAppSelector((state) => state) as IGlobalState;
  const [refundDetail, setRefundDetail] = useState(false);
  const dispatch = useAppDispatch();

  const { mutate: putDepartureDate } = useMutation(
    ['deaprtureDate'],
    (payload: IMedicalDepartureInfoPayload) =>
      updateMedicalDepartureInfo(payload),
  );

  const updateDepartureDate = (departure: string) => {
    const departureDate = format(new Date(departure || ''), 'yyyy-MM-dd');
    putDepartureDate(
      {
        passportNumber: passportNumber || '',
        email,
        departureDate,
      },
      {
        onSuccess: () => {
          dispatch({
            type: 'UPDATE_USER_INFO',
            payload: { departureDate },
          });
        },
      },
    );
  };

  return (
    <Container dir='column' justifyContent='center'>
      <HeaderWrapper>
        <DepartureDate
          nationality={nationality}
          departureDate={departureDate || ''}
          firstRefundDate={firstRefundDate}
          onClick={updateDepartureDate}
        />
      </HeaderWrapper>
      <CurrentStatus />
      {mtcnList.length > 0 && (
        <MTCNWrapper>
          <MTCN data={mtcnList} />
        </MTCNWrapper>
      )}
      {!(mtcnList.length > 0) && (
        <RefundAmount
          refundAmount={Number(refundAmount)}
          nation={nationality}
          onClick={() => history.push(routes.medicalReceipt)}
        />
      )}
      {refundDetail && (
        <RefundDetail
          nation={nationality}
          refund={refundAmountDetail.refunded}
          remittance={refundAmountDetail.remittance}
          van={refundAmountDetail.van}
          unRefund={refundAmountDetail.unRefunded}
          onClose={() => setRefundDetail(false)}
        />
      )}
    </Container>
  );
}

export default TopSection;

const Container = styled(FlexWrap)`
  padding: 0 20px 20px;
  width: 375px;
  @media ${({ theme }) => theme.mobile} {
    width: 100%;
  }
`;

const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 28px;
`;

const MTCNWrapper = styled.div`
  margin-bottom: -32px;
`;
